import React from "react";
import { FaPlus } from "react-icons/fa";
import { SetStateAction, useEffect, useState } from "react";
import Location from "./Location";

function AddTextLocation(props: {
  error: string;
  onClick: (arg0: Location) => void;
}) {
  const [locationName, setLocationName] = useState("");
  const [error, setError] = useState(props.error);

  useEffect(() => {
    setError(props.error);
  }, [props.error]);

  const handleChange = (event: {
    target: { value: SetStateAction<string> };
  }) => {
    setLocationName(event.target.value);
  };

  const handleSubmit = async () => {
    const query = encodeURIComponent(locationName + ", London, UK");
    const url = `https://nominatim.openstreetmap.org/search?q=${query}&format=json&limit=1`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.length > 0) {
          const res = data[0];
          const location = new Location(locationName, [res.lat, res.lon]);
          props.onClick(location);
          setLocationName("");
          setError("");
        } else {
          setError("Location not found");
        }
      })
      .catch((_) => setError("Error while fetching location"));
  };

  const onKeypress = (e: { key: string; preventDefault: () => void }) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="mt-1">
      {error !== "" && <p className="mb-1 text-xs text-red-500">{error}</p>}
      <div
        className={
          "flex h-9 items-center rounded-lg border " +
          (error === "" ? "border-gray-200" : "border-red-400")
        }
      >
        <input
          className="w-full appearance-none bg-transparent px-3 text-sm text-gray-600 placeholder-gray-300 focus:outline-none"
          type="text"
          placeholder="e.g. Kings Cross, or SW1A 2AA"
          value={locationName}
          onChange={handleChange}
          onKeyDown={onKeypress}
        ></input>
        <button
          className="flex h-full w-9 shrink-0 items-center justify-center rounded-r-lg border-l border-gray-200 text-green-600 hover:bg-green-600 hover:text-white"
          type="button"
          aria-label="Add location"
          onClick={handleSubmit}
        >
          <FaPlus />
        </button>
      </div>
    </div>
  );
}

export default AddTextLocation;
